import { useInitializeShoppingCartMutation } from 'src/api/@generated/backend-api';

import { useProductsResponseQueryStateOrThrow } from 'src/hooks/use-products-query';
import { selectSelectedAccountOrThrow } from 'src/state/account/selectors';
import { selectSelectedServiceLocationOrThrow } from 'src/state/address/selectors';
import { CartState } from 'src/state/cart/types';
import { useAppSelector } from 'src/state/thunk-api';

export const useInitializeShoppingCart = () => {
  const selectedAccount = useAppSelector(selectSelectedAccountOrThrow);
  const selectedServiceLocation = useAppSelector(selectSelectedServiceLocationOrThrow);
  const productsResponse = useProductsResponseQueryStateOrThrow();

  const [initializeShoppingCartMutationTrigger, { isLoading, isSuccess, isUninitialized, data: shoppingCart }] =
    useInitializeShoppingCartMutation({
      fixedCacheKey: 'initialize-shopping-cart',
    });

  const initializeShoppingCart = (cart: CartState) =>
    initializeShoppingCartMutationTrigger({
      partnerId: selectedAccount.partnerId,
      initializeShoppingCartRequest: {
        servicePointId: selectedServiceLocation.integrationId,
        billingAccountId: selectedAccount.customerId,
        offerId: productsResponse.offerId,
        numberOfResourcesToAdd: cart.purchase,
        resourcesToUpgrade: cart.upgrade,
      },
    });

  return { initializeShoppingCart, isLoading, isSuccess, isUninitialized, shoppingCart };
};
